import { Authorities } from "props/authoritries";
import { useUser } from "utils/helpers/UserContext";
import GetUser from "./page/GetUser";
import { SuperAdminStatusEnum } from '../../../../props/enum';

const CreateMembershipPlan: React.FC = () => {
  const { authUser, action, superAdmin } = useUser();
  const isPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(
        Authorities.UPDATE_COMMERCIAL_MEMBERSHIP ||
          Authorities.CREATE_COMMERCIAL_MEMBERSHIP
      ));
  if (isPermitted)
    return (
      <>
        <GetUser />
      </>
    );
  return (
    <div className="text-primary-400 text-center h-[60vh] flex justify-center items-center">
      You don't have the permission.
    </div>
  );
};
export default CreateMembershipPlan;
